import { render } from "./MessageModal.vue?vue&type=template&id=6e166fa8"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"

import "./MessageModal.vue?vue&type=style&index=0&id=6e166fa8&lang=scss"
script.render = render

export default script